define.alias("shared/components/shared/restricted-area/modal", "calendar/components/shared/restricted-area/modal");